import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-statistique-user-card',
  templateUrl: './statistique-user-card.component.html',
  styleUrls: ['./statistique-user-card.component.css']
})
export class StatistiqueUserCardComponent implements OnInit {
  donnee: any = [
    {
      user_name: 'Utilisateur_1',
      status: 'En ligne',
      taches: 'Moderation',
    },
    {
      user_name: 'Utilisateur_2',
      status: 'Hors-ligne',
      taches: '-',
    },
    {
      user_name: 'Utilisateur_3',
      status: 'En ligne',
      taches: 'CQ',
    },
    {
      user_name: 'Utilisateur_4',
      status: 'En ligne',
      taches: 'CQ',
    },
    {
      user_name: 'Utilisateur_5',
      status: 'En ligne',
      taches: 'Moderation',
    },
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
